import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery, {
  IBaseQueryResponse
} from "../../../utils/customBaseQuery";
import { Strapi_Image } from "../../content-viewer/notes-widget/notes-slice/notesType";

export type GetSingleAssetResp = IBaseQueryResponse<Array<Strapi_Image>>;

export const UploadGetApi = createApi({
  reducerPath: "UploadGetApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  tagTypes: ["uploadBannerExpense"],
  endpoints: (builder) => ({
    getAssetsFromStrapi: builder.mutation({
      query: (body: any) => {
        return {
          url: `/asset/strapi`,
          method: "POST",
          body
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getSingleAssetFromStrapi: builder.query<any, string>({
      query: (assetId) => {
        return {
          url: `/asset/strapi`,
          method: "POST",
          body: [assetId]
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getAssetsImagesFromStrapi: builder.query({
      query: (assetId) => {
        return {
          url: `/asset/strapi/${assetId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    }),
    getAssetsAudioFromStrapi: builder.query({
      query: (assetId) => {
        return {
          url: `/asset/strapi/audio/${assetId}`,
          method: "GET"
        };
      },
      transformResponse: (response: any) => response.text(),
      extraOptions: { service: "Utility" }
    }),
    getAssetsVideoFromStrapi: builder.query({
      query: (assetId) => {
        return {
          url: `/asset/strapi/video/${assetId}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Utility" }
    })
  })
});

export const {
  useGetAssetsFromStrapiMutation,
  useGetSingleAssetFromStrapiQuery,
  useLazyGetSingleAssetFromStrapiQuery,
  useLazyGetAssetsImagesFromStrapiQuery,
  useGetAssetsAudioFromStrapiQuery,
  useLazyGetAssetsAudioFromStrapiQuery,
  useGetAssetsVideoFromStrapiQuery,
  useLazyGetAssetsVideoFromStrapiQuery
} = UploadGetApi;
